/* eslint-disable import/prefer-default-export */
import http from './httpClient';

export const getProfile = async (cod) => {
  try {
    const token = await localStorage.getItem('user-token');
    const { data } = await http.get(`/patients/${cod}/`, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const editProfile = async (cod, data) => {
  try {
    const token = await localStorage.getItem('user-token');
    const result = await http.patch(`/patients/${cod}/`, data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createCreditCard = async (data) => {
  try {
    const token = await localStorage.getItem('user-token');
    const result = await http.post('/credit_card/', data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCreditCards = async () => {
  try {
    const token = await localStorage.getItem('user-token');
    const { data } = await http.get('/credit_card/', {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateCreditCard = async (data) => {
  try {
    const token = await localStorage.getItem('user-token');
    const result = await http.patch(`/credit_card/${data.id}/`, data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteCreditCard = async (cod) => {
  try {
    const token = await localStorage.getItem('user-token');
    const { status } = await http.delete(`/credit_card/${cod}`, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(status);
  } catch (error) {
    return Promise.reject(error);
  }
};
